// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"0383726d","530":"bee96620","628":"983a87de","778":"0383726d"}[chunkId] + ".chunk.css";
};